module.exports = __webpack_public_path__ + "img/05.4ad96269.jpg";